import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  onPress?: () => void;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  isLast?: boolean;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  onPress,
  isLast,
}) => {
  return (
    <Box
      tag="li"
      borderBottomWidth={isLast ? 0 : 1}
      borderColor="$borderPrimary"
      $largerThanSM={{ display: 'none' }}
    >
      <Link
        aria-current={isActive}
        href={href}
        aria-label="View link"
        analyticsName={analyticsName}
        onPress={onPress}
        display="inline-flex"
        alignItems="center"
        paddingTop="$8x"
        paddingBottom="$8x"
        paddingLeft="$12x"
        paddingRight="$8x"
        backgroundColor={isActive ? '$backgroundStateHoverPrimary' : undefined}
      >
        <Text tag="span" typography="$bodyMedium">
          {name}
        </Text>
      </Link>
    </Box>
  );
};
